import {tarifConstants} from './constants'

const initialState =
    {
        list: [],
        isSending: false,
        error: null
    }

function tarifReducer(state = initialState, action) {
    switch (action.type) {
        case tarifConstants.GetTarifs.REQUEST:
            return {
                ...state,
                isSending: true
            }
        case tarifConstants.GetTarifs.FAILURE:
            return {
                ...state,
                isSending: false,
                error: action.payload
            }
        case tarifConstants.GetTarifs.SUCCESS:
            return {
                ...state,
                isSending: false,
                list: action.payload.result
            }

        case tarifConstants.UpdateTarifs.REQUEST:
            return {
                ...state,
                isSending: true
            }
        case tarifConstants.UpdateTarifs.FAILURE:
            return {
                ...state,
                isSending: false,
                error: action.payload
            }
        case tarifConstants.UpdateTarifs.SUCCESS:
            return {
                ...state,
                isSending: false,
                list: action.payload.result
            }

        case tarifConstants.ClearTarifs:
            return {
                ...state,
                list: []
            }
        default:
            return state
    }
}

export default tarifReducer
